// Cypress-specific store sync
const setupCypressSync = (store) => {
    if (typeof window === 'undefined') return;

    // Always expose for Cypress (even in production during tests)
    if ((process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'stage' && process.env.NODE_ENV !== 'staging')) {
        // Expose store and initial state
        window.store = store;
        window.reduxState = store.getState();

        // Subscribe to all state changes
        store.subscribe(() => {
            const newState = store.getState();
            window.reduxState = newState;

            // Emit custom event for Cypress to listen
            window.dispatchEvent(new CustomEvent('redux:stateChanged', {
                detail: {
                    state: newState,
                    timestamp: Date.now()
                }
            }));
        });

        // Helper methods for Cypress
        window.cypressRedux = {
            getState: () => store.getState(),
            dispatch: (action) => store.dispatch(action),
            waitForState: (predicate, timeout = 5000) => {
                return new Promise((resolve, reject) => {
                    const startTime = Date.now();
                    const checkState = () => {
                        if (predicate(store.getState())) {
                            resolve(store.getState());
                        } else if (Date.now() - startTime > timeout) {
                            reject(new Error('Timeout waiting for state condition'));
                        } else {
                            setTimeout(checkState, 50);
                        }
                    };
                    checkState();
                });
            }
        };

        console.log('Redux store synced for Cypress testing');
    }
};

export default setupCypressSync;